import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { newPassword } from 'actions/Settings';

import flowRight from 'lodash/flowRight';

import { Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Subheader from 'material-ui/Subheader';

import { FormattedMessage } from 'react-intl';

import TextInput from 'components/form/TextInput';
import PanelMessage from 'components/panels/PanelMessage';
import { Field, reduxForm } from 'redux-form';

const styles = {
  paper: {
    padding: 16,
    margin: 8,
  },
  submit: {
    marginTop: 8,
  },
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
  },
};

const validate = ({ OldPassword, NewPassword, ConfirmPassword }) => {
  const errors = {};

  if (!OldPassword) {
    errors.OldPassword = <FormattedMessage id="newPassword.required" />; // 'Þarf að fylla út';
  }

  if (!NewPassword) {
    errors.NewPassword = <FormattedMessage id="newPassword.required" />; // 'Þarf að fylla út';
  } else if (NewPassword.length < 12) {
    errors.NewPassword = <FormattedMessage id="newPassword.length" />; // 'Þarf að vera 12 stafir að lengd';
  } else if (!NewPassword.match(/(?=.*?[A-Z])/)) {
    errors.NewPassword = <FormattedMessage id="newPassword.capital" />; // 'Þarf að innihalda hástaf';
  } else if (!NewPassword.match(/(?=.*?[a-z])/)) {
    errors.NewPassword = <FormattedMessage id="newPassword.letter" />; // 'Þarf að innihalda lástaf';
  } else if (!NewPassword.match(/(?=.*?[0-9])/)) {
    errors.NewPassword = <FormattedMessage id="newPassword.number" />; // 'Þarf að innihalda tölustaf';
  } else if (!NewPassword.match(/(?=.*?[\\#?!@$%^&*-/])/)) {
    errors.NewPassword = <FormattedMessage id="newPassword.special" />; // 'Þarf að innihalda tákn';
  }

  if (!ConfirmPassword) {
    errors.ConfirmPassword = <FormattedMessage id="newPassword.required" />; // 'Þarf að fylla út';
  } else if (ConfirmPassword !== NewPassword) {
    errors.ConfirmPassword = <FormattedMessage id="newPassword.match" />; // 'Lykilorðin stemma ekki';
  }

  return errors;
};

class NewPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      newPasswordLoading,
      handleSubmit,
      hasError,
      newPasswordError,
      invalid,
    } = this.props;

    return (
      <Col xs={12} sm={8} smOffset={2} md={6} mdOffset={3} style={{ paddingTop: 16, paddingBottom: 16 }}>
        <Subheader style={styles.subheader}><FormattedMessage id="newPassword.title" /></Subheader>
        {hasError && !newPasswordLoading && newPasswordError &&
        <PanelMessage
          iconName="error"
          type="error"
          message={newPasswordError.Message !== 'The request is invalid.' ?
            newPasswordError.Message : <FormattedMessage id="newPassword.error" />}
        />
        }
        <Paper style={styles.paper}>
          {newPasswordLoading && <CircularProgress />}
          <form onSubmit={handleSubmit}>
            <Field
              name="OldPassword"
              label={<FormattedMessage id="newPassword.currentPassword" />}
              floatingLabelFixed
              component={TextInput}
              type="password"
              customStyle={{ marginTop: 0 }}
            />
            <Field
              name="NewPassword"
              label={<FormattedMessage id="newPassword.newPassword" />}
              floatingLabelFixed
              component={TextInput}
              type="password"
              customStyle={{ marginTop: 0 }}
            />
            <Field
              name="ConfirmPassword"
              label={<FormattedMessage id="newPassword.newPasswordConfirm" />}
              floatingLabelFixed
              component={TextInput}
              type="password"
              customStyle={{ marginTop: 0 }}
            />
            <RaisedButton
              label={<FormattedMessage id="newPassword.save" />}
              style={styles.submit}
              icon={
                newPasswordLoading && <CircularProgress style={{ lineHeight: '16px' }} size={16} thickness={2} />
              }
              type="submit"
              primary
              fullWidth
              disabled={invalid || newPasswordLoading}
            />
          </form>
        </Paper>
      </Col>
    );
  }
}

NewPassword.propTypes = {
  newPasswordLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  newPasswordError: PropTypes.object,
};

export default flowRight(
  connect(
    ({ SettingsReducer }) => ({
      ...SettingsReducer,
      form: 'NewPassword',
      validate,
    }),
    dispatch => ({
      onSubmit: data => dispatch(newPassword(data)),
    }),
  ),
  reduxForm({}),
)(NewPassword);



// WEBPACK FOOTER //
// ./src/containers/NewPassword.js